import React from 'react';

import { UserUploadActionProgress } from '../../../models/ApiResponseModels/UserUploadActionProgressModel';
import Details from './Details';
import { UserImportType } from  '@/models/UserImportType';

interface Step5Props {
    progressReport: UserUploadActionProgress
    userImportType: UserImportType
}


const Step5 = ({progressReport, userImportType}: Step5Props) => {
 
    function getDisplayNameForUserImportType(){
        switch(userImportType){
            case UserImportType.Fullsync:
                return "Bulk Update"
            case UserImportType.Starters:
                return "Starters"
            case UserImportType.Leavers:
                return "Leavers"
        }
    }
    
    return progressReport && progressReport.UserComparisonReport ? (
        <>  
            <h3>Review and Apply Changes</h3>

            <h2>Import Type: {getDisplayNameForUserImportType()}</h2>

            <p>Here’s a summary of the changes we’ll apply when you confirm this import.</p>

            <p>We’ll send you an email when the changes have been applied.</p>
            
            <Details userComparisonReport={progressReport.UserComparisonReport} userImportId={progressReport.UserImportId}/>
        </>
    ) : null;
};

export default Step5;